// ── 계약 모달 — 홍보물 섹션 ────────────────────────────────────────────────────
// 계약 저장 시 홍보물 관리 DB에 별도 등록됨 (savePromoOrder 유틸 참조)
import React from 'react';
import { PromoItemSearchInput } from './PromoItemSearchInput';
import {
  sectionCard, sectionTitleBar, sectionDot,
  optionalBadge, countNumInput, unitLabel,
} from './modalStyles';

export function PromoSection({ form, setForm, setField, autoFocusNew, setAutoFocusNew, promotionalItemsList }) {
  return (
    <div style={sectionCard}>
      <div style={sectionTitleBar('#7c3aed')}>
        <span style={sectionDot('#7c3aed')} />
        홍보물
        <span style={optionalBadge}>선택</span>
      </div>

      {/* 홍보물 접수일자 + 메모 — 같은 행에 배치, 메모는 오른쪽 공간 채움 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, flexWrap: 'wrap', minWidth: 0 }}>
        <span style={{ fontSize: 12, color: '#7c3aed', fontWeight: 700, flexShrink: 0 }}>접수일자</span>
        <input
          type="date"
          value={form.promoReceivedDate || ''}
          onChange={(e) => setForm((prev) => ({ ...prev, promoReceivedDate: e.target.value }))}
          style={{ border: '1.5px solid rgba(124,58,237,0.3)', borderRadius: 7, padding: '4px 8px', fontSize: 12, color: 'var(--text)', outline: 'none', background: 'var(--bg-card)', flex: '0 1 140px', minWidth: 130, boxSizing: 'border-box' }}
        />
        {/* 홍보물 주문 메모 — 입력 시 홍보물 관리 고객정보 메모에 추가됨 */}
        <textarea
          style={{
            border: '1px solid var(--border)', borderRadius: 7,
            padding: '4px 8px', fontSize: 11, color: 'var(--text)',
            background: 'var(--bg-card)', resize: 'none',
            flex: '1 1 160px', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box',
            lineHeight: 1.5, outline: 'none',
            height: 28,  // date input과 동일 높이
          }}
          value={form.promoMemo || ''}
          onChange={(e) => setField('promoMemo', e.target.value)}
          placeholder="입력시 홍보물 관리 고객정보 메모에 추가됨 (선택)"
        />
      </div>

      {/* 추가된 홍보물 행 목록 */}
      {(form.promoItems || []).map((item, idx) => (
        <div key={idx} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap' }}>
          {/* 홍보물 종류 — 검색 자동완성 */}
          <PromoItemSearchInput
            value={item.item_name}
            unitPrice={item.unit_price}
            promotionalItemsList={promotionalItemsList}
            autoFocus={idx === (form.promoItems || []).length - 1 && autoFocusNew}
            onAutoFocused={() => setAutoFocusNew(false)}
            onSelect={(found) => {
              setForm((prev) => {
                const items = [...prev.promoItems];
                if (!found) {
                  items[idx] = { item_id: '', item_name: '', unit_price: 0, quantity: items[idx].quantity || '1' };
                } else {
                  items[idx] = { item_id: found.id, item_name: found.name, unit_price: found.price, quantity: items[idx].quantity || '1' };
                }
                return { ...prev, promoItems: items };
              });
            }}
          />
          {/* 수량 입력 */}
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            style={{ ...countNumInput, width: 52 }}
            placeholder="수량"
            value={item.quantity || ''}
            onChange={(e) => {
              const v = e.target.value.replace(/[^0-9]/g, '');
              setForm((prev) => {
                const items = [...prev.promoItems];
                items[idx] = { ...items[idx], quantity: v };
                return { ...prev, promoItems: items };
              });
            }}
          />
          <span style={unitLabel}>개</span>
          {/* 삭제 버튼 */}
          <button
            type="button"
            style={{ border: '1px solid #ef4444', borderRadius: 6, padding: '3px 8px', background: 'var(--bg-card)', color: '#dc2626', fontSize: 11, cursor: 'pointer', flexShrink: 0 }}
            onClick={() => setForm((prev) => ({ ...prev, promoItems: prev.promoItems.filter((_, i) => i !== idx) }))}
          >
            삭제
          </button>
        </div>
      ))}

      {/* + 홍보물 추가 버튼 */}
      <button
        type="button"
        style={{ border: '1.5px dashed #7c3aed', borderRadius: 8, padding: '7px 14px', background: 'rgba(124,58,237,0.08)', color: '#7c3aed', fontWeight: 700, fontSize: 12, cursor: 'pointer', width: '100%', marginTop: 2 }}
        onClick={() => {
          setForm((prev) => ({ ...prev, promoItems: [...(prev.promoItems || []), { item_id: '', item_name: '', quantity: '1', unit_price: 0 }] }));
          setAutoFocusNew(true); // 새로 추가된 마지막 행 검색창 자동 포커스
        }}
      >
        + 홍보물 추가
      </button>
    </div>
  );
}
